<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #title-buttons>

        <t-button @click="confirmReverse()"
                  outline-danger
                  v-show="(command === 'delete' || command === 'view') && objValid(form.finishedDate)"
                  :sending="reverseFinish"
                  enable-loader
                  :title="!relationAccessSubValidation('sub-occurrence-reverse-finish') ? 'Perfil de acesso não habilitado para estorno de finalização' : ''"
                  :disabled="!relationAccessSubValidation('sub-occurrence-reverse-finish')">
          <b-icon-clipboard-x class="mr-1"></b-icon-clipboard-x>
          Estornar finalização
        </t-button>

      </template>

      <template #default="{status}">

        <t-form-tab title="Dados Básicos">

          <t-form-card title="Apontamento">

            <b-row>

              <t-input v-model="form.occurrenceCodeLabel"
                       cols="3"
                       label="Cód. Apontamento"
                       fixed
                       highlight
                       help="Código inserido automaticamente após a inclusão"/>

              <t-input v-model="form.issueDate" cols="3" date date-now label="Data de Emissão" required/>

              <b-col cols="3">

                <t-input v-model="form.deadline" date label="Prazo"/>


                <small
                    v-if="deadlineStatus"
                    :class="{
            'text-success': deadlineStatus.type === 'future',
            'text-warning': deadlineStatus.type === 'today',
            'text-danger': deadlineStatus.type === 'late'
          }"
                >
                  {{ deadlineStatus.text }}
                </small>

                <small v-if="deadlineStatus && objValid(form.deadlineOriginal)"> - </small>

                <small v-if="objValid(form.deadlineOriginal)">Original: {{ form.deadlineOriginal | date }}
                  <t-help title="Primeiro prazo cadastrado"/>
                </small>


              </b-col>


              <t-input label="Conclusão (%)"
                       cols="3"
                       range
                       v-model="form.conclusion"/>

            </b-row>

            <b-row>

              <b-col v-if="objValid(form.otherCodeLabel)" cols="4">
                <t-input v-model="form.otherCodeLabel" highlight v-if="pageFormIsLoaded" fixed
                         label="Cód. Interno"/>
              </b-col>

              <b-col :cols="objValid(form.otherCodeLabel) ? 4 : 6">

                <t-input v-model="form.occurrenceStatusId" v-if="pageFormIsLoaded" required
                         :options="typeOccurrenceStatusOptions"
                         label="Status Apontamento" radio/>

              </b-col>

              <b-col :cols="objValid(form.otherCodeLabel) ? 4 : 6">

                <t-input v-model="form.typeCriticalityId" :options="typeCriticalityOptions"
                         label="Criticidade"
                         stacked
                         first-default
                         select
                         required
                />

              </b-col>

            </b-row>

            <b-row>

              <b-col cols="12">

                <t-input-person executor
                                :status="status"
                                :command="command"
                                v-model="form.executorId"/>

              </b-col>


            </b-row>

          </t-form-card>

          <t-form-card title="Mapeamento">

            <b-row>

              <t-input fixed v-model="environmentResume.enterprise" cols="4" label="Empreendimento"/>

              <t-input fixed v-model="environmentResume.division" cols="4" label="Divisão"/>

              <t-input fixed v-model="environmentResume.spotFolder" cols="4" label="Pavimento"/>


            </b-row>

            <b-row>

              <b-col cols="8">

                <!--Não poderá alterar devido consistência de informação do createdId-->
                <t-input-code-label environment @onResume="onResumeEnvironment"
                                    :block-enterprise-id="form.enterpriseId"
                                    :status="status"
                                    :command="command"
                                    :fixed="!isInsert() && !isUpdate()"
                                    required
                                    :add-error="error.environmentId"
                                    v-model="form.environmentId"/>


                <t-msg warning v-if="isUpdate() && form.typeOrigin === OccurrenceOriginType.type.CHECKLIST"><b>Atenção: </b>mudanças no ambiente não são replicadas na inspeção de origem. <t-help title="Ao alterar o ambiente no apontamento, ele passa a ser considerado o atual. Em novas inspeções no mesmo local, o apontamento será vinculado ao novo ambiente. O ambiente de origem registrado na inspeção inicial será mantido para garantir a consistência das informações." /></t-msg>

              </b-col>

              <b-col cols="4">

                <t-input label="Complemento do Ambiente"
                         help="Utilize caso desejar acrescentar para identificar o ambiente correto."
                         v-model="form.environmentComplement"/>

              </b-col>

            </b-row>

          </t-form-card>

          <t-form-card title="Detalhes">

            <b-row>

              <b-col cols="12">

                <t-input-code-label type-checklist-item
                                    :fixed="!isInsert() && !isUpdate()"
                                    :status="status"
                                    :command="command"
                                    required
                                    v-model="form.typeChecklistItemId"/>

              </b-col>

            </b-row>

            <b-row>

              <b-col cols="12">

                <div class="d-flex">

                  <div>Anomalia</div>

                  <b-form-checkbox class="ml-3" v-model="form.typePathologyNotFound" switch>

                    <small>Outra?</small>

                  </b-form-checkbox>

                </div>

                <t-input-code-label type-pathology
                                    :status="status"
                                    :command="command"
                                    @onResume="getResumeTypePathology"
                                    v-show="!form.typePathologyNotFound"
                                    hide-label
                                    :required="!form.typePathologyNotFound"
                                    v-model="form.typePathologyId"/>

                <b-row v-show="form.typePathologyNotFound">
                  <t-input
                      cols="4"
                      v-model="form.sectorId"
                      label="Categoria"
                      hide-label
                      placeholder="Categoria"
                      :options="sectorOptions" select
                      :required="form.typePathologyNotFound"/>

                  <t-input
                      cols="8"
                      v-model="form.typePathologyNotFoundOther"
                      hide-label label="Anomalia - Outra" placeholder="Informe a anomalia desejada"
                      :required="form.typePathologyNotFound"/>
                </b-row>

              </b-col>

            </b-row>

            <b-row>

              <b-col cols="12">

                <div class="d-flex">
                  <label>Origem *</label>
                  <t-help click modal-title="Origem da Anomalia">

                    <div class="help-box help-anomaly-origin">

                      <p>
                        Selecione a origem que melhor representa a causa prov&aacute;vel da anomalia observada.
                        Caso n&atilde;o seja poss&iacute;vel concluir no momento da inspe&ccedil;&atilde;o, utilize a op&ccedil;&atilde;o
                        <strong>N&atilde;o determinada</strong>.
                      </p>

                      <ul>
                        <li class="mb-2">
                          <strong>End&oacute;gena</strong><br/>
                          Anomalia originada por falhas de projeto, execu&ccedil;&atilde;o, materiais ou sistemas
                          construtivos da pr&oacute;pria edifica&ccedil;&atilde;o.
                        </li>
                        <li class="mb-2">
                          <strong>Ex&oacute;gena</strong><br/>
                          Anomalia causada por agentes externos &agrave; edifica&ccedil;&atilde;o, como a&ccedil;&otilde;es
                          clim&aacute;ticas, ambientais, do entorno ou interfer&ecirc;ncias de terceiros.
                        </li>
                        <li class="mb-2">
                          <strong>Funcional / Uso</strong><br/>
                          Anomalia decorrente do uso inadequado, opera&ccedil;&atilde;o incorreta, sobrecarga ou falta
                          de manuten&ccedil;&atilde;o do sistema ou elemento inspecionado.
                        </li>
                        <li class="mb-2">
                          <strong>N&atilde;o determinada</strong> <em>(opção padrão)</em><br/>
                          Utilizada quando n&atilde;o &eacute; poss&iacute;vel definir com seguran&ccedil;a a origem da
                          anomalia no momento da inspe&ccedil;&atilde;o.
                        </li>
                      </ul>

                      <div>Conforme o tipo de anomalia é possível parametrizar a origem provável, podendo ser revisada
                        manualmente para melhor escolha.
                      </div>

                    </div>


                  </t-help>
                </div>

                <t-input v-model="form.typeAnomalyOrigin" hide-label radio :options="AnomalyOriginType.list" required
                         label="Origem da Anomalia"/>


              </b-col>


            </b-row>

            <t-input v-model="form.description"
                     textarea max-length="1000"
                     rows="10"
                     enable-optimize-ai
                     label="Descrição técnica"
            />

            <!--
                        <t-input textarea v-if="isInsert()" label="Comentário inicial"
                                 help="Será inserido na guia 'Comentários' automaticamente, depois basta atualizar pela guia de comentários."
                                 v-model="form.lastComment"/>
                        <t-input textarea fixed v-else label="Último comentário" v-model="form.lastComment"/>
            -->

          </t-form-card>


          <t-form-card title="Gerenciamento de Risco">

            <b-row>

              <t-input select cols="3" label="Gravidade" v-model="form.typeSeverity"
                       :options="SeverityType.list"/>

              <t-input select cols="3" label="Urgência" v-model="form.typeUrgency"
                       :options="UrgencyType.list"/>

              <t-input select cols="3" label="Tendência" v-model="form.typeTrend"
                       :options="TrendType.list"/>

              <b-col cols="3">
                <t-occurrence-risk :type-severity="form.typeSeverity" :type-urgency="form.typeUrgency"
                                   :type-trend="form.typeTrend"/>
              </b-col>

            </b-row>

          </t-form-card>

          <t-form-card title="Normas Técnicas">

            <t-msg info v-if="regulationList.length === 0">Nenhuma norma técnica cadastrada para possibilitar o vinculo
              com apontamentos. Caso desejar cadastre através do menu 'Inspeções' > 'Configurações' > <a
                  href="/checklist/regulation" target="_blank">'Normas Técnicas'</a></t-msg>

            <div v-else>

              <t-button v-if="!showRegulation && form.regulations.length === 0" @click="showRegulation = true" small>
                <b-icon-bookmark-check class="mr-2"/>
                Aplicar Normas Técnicas
              </t-button>

              <t-table
                  v-if="showRegulation || form.regulations.length > 0"
                  enable-checked
                  v-model="form.regulations"
                  :command="command"
                  :items="regulationList"
                  :fields="viewFieldsRegulation"
                  title-items="normas"
                  link-primary-column="title"
                  table-bordered
                  disable-actions-column
                  primary-key-column="regulationId">

                <template #first-column="{item}">

                  <span
                      class="badge badge-light"
                      :style="{'background-color': item.typeRegulationBackgroundColor,'color': item.typeRegulationTextColor}">{{
                      item.name
                    }}</span>
                  <br/>
                  {{ item.title }}
                  <t-help :title="item.description"></t-help>


                </template>

              </t-table>


            </div>

          </t-form-card>

          <t-form-card title="Inspeção" v-if="form.typeOrigin === OccurrenceOriginType.type.CHECKLIST">

            <t-msg info>Caso atualizar as informações do apontamento os dados serão atualizados também na inspeção de
              origem, com exceção do <b>ambiente (caso alterado)</b> e das <b>imagens</b>.
            </t-msg>

            <b-row>

              <t-input cols="6" v-model="form.checklistEnvironment.startDate" label="Data início" datetime fixed/>
              <t-input cols="6" v-model="form.checklistEnvironment.finishDate" label="Data término" fixed datetime/>

            </b-row>

            <t-input v-model="form.checklist.typeChecklist" label="Modelo" fixed/>

            <b-button
                :to="{path: '/checklist/'+form.checklist.checklistNumber}"
                class="mt-2"
                variant="outline-primary" target="_blank">
              <b-icon-box-arrow-up-right class="mr-2"/>
              Detalhar Inspeção de Origem
            </b-button>

          </t-form-card>

          <t-form-card title="Cadastro" v-if="!isInsert() && pageFormIsLoaded">

            <b-row>

              <t-input cols="6" v-model="form.logControl.createdUser" label="Usuário Criação" fixed/>
              <t-input cols="6" v-model="form.logControl.createdDate" label="Data Criação" fixed datetime/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.logControl.updatedUser" label="Usuário Modificação" fixed/>
              <t-input cols="6" v-model="form.logControl.updatedDate" label="Data Modificação" fixed datetime/>

            </b-row>

          </t-form-card>


        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Fotos" hash="photo" :disabled="!relationAccessPageGeneral('checklist-occurrence-file')"
                    lazy>

          <OccurrenceFile :occurrence-file-type="occurrenceFileType" :only-view="isView() || isDelete()" type-image
                          :foreign-key="form[fieldKey]"/>

        </t-form-tab>


        <t-form-tab title="Comentários" hash="comment" :disabled="validationCommentOption === 0" lazy>


          <Comment :foreign-key="currentPage.pageId" :relation-key="form[fieldKey]"
                   disabled-title
                   disabled-category
                   disabled-keyword>


            <template #modal-header>

              <t-msg info v-if="isUpdate() && form.typeOrigin === OccurrenceOriginType.type.CHECKLIST"><b>Apontamento
                relacionado com Inspeção</b><br/>Este novo comentário irá constar somente no relatório de apontamento
                por empreendimento.<br/>Caso desejar que conste no relatório de apontamento por inspeção é necessário
                corrigir na origem da inspeção. <br/>

                <b-link @click="infoCommentChecklist()">Orientações para inserir um comentário na inspeção original
                </b-link>
              </t-msg>

            </template>

          </Comment>


        </t-form-tab>

        <!--        <t-form-tab title="Avisos">


                </t-form-tab>-->

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import OccurrenceOriginType from "@/model/types/modules/checklist/OccurrenceOriginType";
import TypeCriticalityService from "@/services/modules/checklist/TypeCriticality.service";
import TypeOccurrenceStatusService from "@/services/modules/checklist/TypeOccurrenceStatus.service";
import OccurrenceFile from "@/views/modules/checklist/OccurrenceFile";
import OccurrenceFileType from "@/model/types/modules/checklist/OccurrenceFileType";
import Comment from "@/views/modules/general/Comment";
import SectorService from "@/services/modules/agent/Sector.service";
import RegulationService from "@/services/modules/checklist/Regulation.service";
import SeverityType from "@/model/types/modules/checklist/SeverityType";
import TrendType from "@/model/types/modules/checklist/TrendType";
import UrgencyType from "@/model/types/modules/checklist/UrgencyType";
import tOccurrenceRisk from "@/components/template/form/input/t-occurrence-risk.vue";
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";
import AnomalyOriginType from "@/model/types/modules/checklist/AnomalyOriginType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {OccurrenceFile, Comment, tOccurrenceRisk},
  name: 'OccurrenceForm',
  data() {
    return {
      AnomalyOriginType,
      OccurrenceOriginType,
      OccurrenceFileType,
      SeverityType,
      TrendType,
      UrgencyType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "occurrenceId",
      form: {
        occurrenceId: 0,
        occurrenceEnterpriseNumber: "",
        typeOrigin: OccurrenceOriginType.type.MANUAL,/*Padrão para inclusões será manual*/
        checklistId: 0,
        checklistEnvironmentId: 0,
        environmentComplement: "",
        executorId: 0,
        enterpriseId: 0,
        environmentId: 0,
        finishedDate: "",
        beforeFileId: 0,
        afterFileId: 0,
        lastComment: "",
        lastCommentId: 0,
        lastWarningId: 0,
        lastWarningSend: "",
        lastWarningType: 0,
        occurrenceCodeLabel: "",
        occurrenceNumber: 0,
        occurrenceStatusId: 0,
        typeCriticalityId: 0,
        sectorId: 0, //Utilizado somente quando typePathologyNotFound = true
        typePathologyId: 0,
        typePathologyNotFound: false,
        typePathologyNotFoundOther: "",
        issueDate: "",
        deadline: "",
        deadlineOriginal: "",
        description: "",
        positionX: 0,
        positionY: 0,
        positionScale: 0.0,
        positionRotation: 0,
        checklist: {},
        checklistEnvironment: {},
        regulations: [],
        budgetEnabled: false,
        budgetPrice: 0,
        budgetQuantity: 0,
        budgetUnit: "",
        conclusion: 0,
        typeSeverity: 0,
        typeTrend: 0,
        typeUrgency: 0,
        volumetryQuantity: 0,
        volumetryUnit: "",
        status: 1,
        typeAnomalyOrigin: 0,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        environmentId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      reverseFinish: false,
      occurrenceFileType: 0,
      sectorOptions: [],
      typeOccurrenceStatusOptions: [],
      showRegulation: false,
      regulationList: [],
      viewFieldsRegulation: [
        {key: "title", label: "Norma Técnica"},
        {key: "typeRegulation", label: "Categoria"},
      ],
      typeCriticalityOptions: [],
      validationCommentOption: 0,
      environmentResume: {
        environmentId: 0,
        environmentCodeLabel: "",
        spotFolderId: 0,
        enterpriseId: 0,
        enterpriseDivisionId: 0,
        division: "",
        name: "",
        spotFolder: "",
        enterprise: "",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.validationCommentOption = this.getRenderRule('validationCommentOption')

      await TypeCriticalityService.selectList("").then((list) => {
        this.typeCriticalityOptions = list
      }).catch(error => this.responseError(error))

      await TypeOccurrenceStatusService.selectList("").then((list) => {
        this.typeOccurrenceStatusOptions = list
      }).catch(error => this.responseError(error))

      await SectorService.selectList().then((list) => {
        this.sectorOptions = list
      }).catch(error => this.responseError(error))

      await RegulationService.selectAll().then((list) => {
        this.regulationList = list
      }).catch(error => this.responseError(error))

      if (this.isInsert()) {

        //Primeiras opções como padrão, pois não esta funcionando o first-default
        if (this.typeCriticalityOptions.length > 0)
          this.form.typeCriticalityId = this.typeCriticalityOptions[0].value

        if (this.typeOccurrenceStatusOptions.length > 0)
          this.form.occurrenceStatusId = this.typeOccurrenceStatusOptions[0].value


        //Por padrão na inclusão as fotos serão do tipo inclusão, podendo ser alterado após o upload
        this.occurrenceFileType = OccurrenceFileType.type.BEFORE


      } else {

        if (this.isUpdate() && (this.form.finishedDate !== undefined && this.form.finishedDate !== '')) {
          //Bloqueia a exibição para evitar inconsistências também.
          this.command = 'view'
        }

        //Já nos demais casos será por padrão como durante, podendo ser alterado após o upload
        this.occurrenceFileType = OccurrenceFileType.type.DURING //Mesmo neste caso o padrão será considerado antes.


      }


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      if ((this.form.typeSeverity > 0 || this.form.typeUrgency > 0 || this.form.typeTrend > 0) && (this.form.typeSeverity === 0 || this.form.typeUrgency === 0 || this.form.typeTrend === 0)) {
        ui.msgError(this, 'Você preencheu um dos campos da matriz de risco GUT, porém não preencheu os demais, neste caso é permitido deixar todos em branco ou preencher todos para que o cálculo seja correto.')
      } else {
        await this.setSendingDefault()
      }


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    infoCommentChecklist() {
      ui.msg(this, 'Orientações', 'Utilize estas instruções somente se for gerar um <b>Relatório de Apontamento por Inspeção</b>, para o Relatório de Apontamento por Empreendimento não é necessário, pois sempre é exibido o último comentário por padrão.<br /><br />1) Acesse a inspeção onde deseja alterar a comentário.<br />2) Estorne a Finalização da Inspeção<br />3) Estorne a finalização do ambiente relacionado<br />4) Acesse o apontamento relacionado e insira o comentário.<br /><br />Desta forma teremos como saber qual a inspeção exata deseja inserir o comentário e por tanto gerar o relatório de inspeção com comentário.')
    },

    onResumeEnvironment(resume) {
      this.environmentResume = resume
    },
    async confirmReverse() {

      ui.msgConfirm(this, 'ESTORNO DA FINALIZAÇÃO', '<span class="text-danger">Tem certeza que deseja realizar o estorno da finalização deste Apontamento <b>' + this.form.occurrenceCodeLabel + '</b>?', async () => {

        this.reverseFinish = true

        await http.get(this.userAuth.currentPage.path + "/reverse-finish/" + this.form.occurrenceId).then(async () => {

          await this.goPath(this.userAuth.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Apontamento ' + this.form.occurrenceCodeLabel + ' foi estornado com sucesso!'
          })

        }).catch(error => ui.generalResponseError(this, error))

        this.reverseFinish = false

      })

    },

    async getResumeTypePathology(resume) {

      if (this.form.typeAnomalyOrigin === 0) {
        //Não há opção escolhida

        if (this.objValid(resume.defaultTypeAnomalyOrigin) && resume.defaultTypeAnomalyOrigin > 0) {
          //Opção de acordo com tipo de Anomalia
          this.form.typeAnomalyOrigin = resume.defaultTypeAnomalyOrigin
        } else {
          //Opção padrão geral
          this.form.typeAnomalyOrigin = AnomalyOriginType.type.UNDETERMINED
        }

      }

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  computed: {
    deadlineStatus() {
      if (!this.objValid(this.form.deadline)) {
        return null
      }

      const today = new Date()
      const diff = ui.dateDiff(today, this.form.deadline)

      if (diff > 0) {
        return {
          type: 'future',
          text: `Faltam ${diff} dia(s)`
        }
      }

      if (diff === 0) {
        return {
          type: 'today',
          text: 'Vence hoje'
        }
      }

      return {
        type: 'late',
        text: `Atrasado há ${Math.abs(diff)} dia(s)`
      }
    }
  },

}
</script>

